import React, { useRef, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface TnCDialogProps {
  open: boolean
  onClose: () => void
}

const TnCDialog: React.FC<TnCDialogProps> = ({ open, onClose }) => {
  const closeButtonRef = useRef<HTMLButtonElement | null>(null)
  const pdfUrl = `${import.meta.env.BASE_URL}terms-and-conditions.pdf`

  useEffect(() => {
    if (open) {
      // Move focus to close button when the dialog opens
      setTimeout(() => closeButtonRef.current?.focus(), 100)
    }
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      scroll='paper'
      aria-labelledby='tnc-dialog-title'
    >
      <DialogTitle
        id='tnc-dialog-title'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        <Typography variant='h6' component='span'>
          Terms and Conditions
        </Typography>
        <IconButton
          aria-label='Close Terms and Conditions dialog'
          onClick={onClose}
          size='small'
          ref={closeButtonRef}
          sx={{
            '&:focus-visible': {
              outline: 'none',
              border: '2px solid #000',
              borderRadius: '4px',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0, height: '75vh' }}>
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Provide a keyboard accessible button so users can open the PDF in a new tab */}
          <Box sx={{ flex: 1 }}>
            <iframe
              src={pdfUrl}
              title='Terms and Conditions'
              width='100%'
              height='100%'
              style={{ border: 'none', display: 'block' }}
              aria-label='Terms and Conditions PDF document'
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default TnCDialog
